import React from "react";
import CommandGrid from "../components/CommandGrid";
import GlyphField from "../components/GlyphField";
import GlyphCard from "../components/GlyphCard";
import { useKami } from "../context/KamiContext";

/**
 * ObserverRingPage.js
 *
 * The central dashboard of the Kami system.
 * Displays command buttons, animated glyph field, and active glyph detail.
 */

export default function ObserverRingPage() {
  const { focusedGlyph } = useKami();

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "black", color: "#00ffff", padding: "20px", fontFamily: "Segoe UI, sans-serif" }}>
      <header style={{ marginBottom: "20px" }}>
        <h1 style={{ fontSize: "2rem" }}>⟁ Kami Observer Ring</h1>
        <p style={{ fontSize: "0.9rem", color: "#88f" }}>
          Real-time recursive interface | Powered by Glyph Memory
        </p>
      </header>

      <CommandGrid />
      <GlyphField />
      {focusedGlyph && <GlyphCard glyph={focusedGlyph} />}
    </div>
  );
}
